/**
 * Place Material UI Theme props in here. These define the defaults of all instances
 * @see {@link https://material-ui.com/customization/globals/}
 */

export const DEFAULT_PROPS = {


};
